import { render } from "./suggestDetailPopover.vue?vue&type=template&id=eb98cffc&scoped=true"
import script from "./suggestDetailPopover.vue?vue&type=script&lang=js"
export * from "./suggestDetailPopover.vue?vue&type=script&lang=js"

import "./suggestDetailPopover.vue?vue&type=style&index=0&id=eb98cffc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb98cffc"]])

export default __exports__